<div
  class="contact-form-wrap"
  [ngClass]="{
    tablet: globalUtilsService.isTablet(),
    mobile: globalUtilsService.isMobile()
  }"
>
  <app-input-select
    class="input"
    [control]="contactFormService.form.get(FormControlName.PadraoEntrada)"
    [controlName]="FormControlName.PadraoEntrada"
    [options]="[
      { label: 'Monofásico', value: 'Monofásico' },
      { label: 'Trifásico', value: 'Trifásico' }
    ]"
    label="Padrão de entrada*"
    placeholder="Padrão de entrada*"
  ></app-input-select>

  <app-input-text
    class="input"
    [control]="contactFormService.form.get(FormControlName.MediaConsumo)"
    [controlName]="FormControlName.MediaConsumo"
    label="Média mensal de consumo? (kWh)*"
    placeholder="Média mensal de consumo?*"
    [mask]="mediaConsumoMask"
  ></app-input-text>

  <app-input-text
    class="input"
    [control]="contactFormService.form.get(FormControlName.PrecoKWH)"
    [controlName]="FormControlName.PrecoKWH"
    label="Preço do kWh?"
    placeholder="Preço do kWh?"
    [mask]="precoKWHMask"
  ></app-input-text>

  <div class="two-inputs">
    <app-input-select
      class="input estado"
      [control]="contactFormService.form.get(FormControlName.Estado)"
      [controlName]="FormControlName.Estado"
      [options]="estados"
      [controlName]="FormControlName.Estado"
      label="Estado*"
      placeholder="Estado*"
    ></app-input-select>
    <app-input-text
      class="input cidade"
      [control]="contactFormService.form.get(FormControlName.Cidade)"
      [controlName]="FormControlName.Cidade"
      [controlName]="FormControlName.Cidade"
      label="Cidade*"
      placeholder="Cidade*"
    ></app-input-text>
  </div>

  <app-input-text
    class="input"
    [control]="contactFormService.form.get(FormControlName.Nome)"
    [controlName]="FormControlName.Nome"
    label="Nome e sobrenome*"
    placeholder="Seu nome*"
  ></app-input-text>

  <app-input-text
    class="input"
    [control]="contactFormService.form.get(FormControlName.Telefone)"
    [controlName]="FormControlName.Telefone"
    label="Telefone"
    maskMode="phone"
    placeholder="Telefone*"
  ></app-input-text>

  <app-input-text
    class="input"
    [control]="contactFormService.form.get(FormControlName.Email)"
    [controlName]="FormControlName.Email"
    label="Seu e-mail"
    placeholder="Seu e-mail*"
  ></app-input-text>

  <app-input-button
    class="button"
    (trigger)="sendMessage()"
    [disabled]="isSendingMessage"
  ></app-input-button>
</div>
